import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: 3,
	y: 7,
	width: 10,
	height: 2,
	rx: 1,
	fill: "black"
}));
export default SvgMinus;
